<template>
  <!--修改应用的appid-->
  <el-dialog
    title="组件信息"
    :visible.sync="isVisible"
    :append-to-body="true"
    :modal-append-to-body="false"
    custom-class="changeRectAppIdDialog"
  >
    <div class="verticallyCenter content-item">
      <span class="w76">名称</span>
      <span class="flex1">{{curRectInfo.name}}</span>
    </div>
    <div class="verticallyCenter mt16 content-item">
      <span class="w76">创建时间</span>
      <span class="flex1">{{curRectInfo.createTime}}</span>
    </div>
    <div class="verticallyCenter mt12 content-item">
      <span class="w76">ID</span>
      <div :class="['flex1',showChangeId?'editing':'']">
        <input
          class="component-id-inp"
          type="text"
          id="componentId"
          ref="componentNameInp"
          :readonly="!showChangeId"
          :value="curRectInfoVal.appId"
          @focus="getComponentIdFocus($event)"
          @blur="showChangeId = false"
        />
        <span class="component-name-edit" v-show="!showChangeId">
               <span class="icon icon-portal-copy1" @click.self="copyComponentId"></span>
               <span class="icon icon-portal-edit" @click.self="editComponentId"></span>
        </span>
        <span class="icon icon-portal-check-small" v-if="showChangeId" @mousedown="changeComponentName('')"></span>
        <span class="icon icon-portal-close-small" v-if="showChangeId" @mousedown="changeComponentName('', 2)"></span>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "EditComponentIdDialog",
  props:{
    curRectInfo:{
      type: Object,
      default: null
    },
    dialogEditComponentId:{
      type: Boolean,
      default: false
    }
  },
  data(){
    return{
      showChangeId:false
    }
  },
  computed:{
    isVisible:{
      get(){
        return this.dialogEditComponentId
      },
      set(val){
        this.$emit("update:dialogEditComponentId",val)
      }
    },
    curRectInfoVal:{
      get(){
        return this.curRectInfo
      },
      set(val){
        debugger
        this.$emit("update:curRectInfo",val)
      }
    },
  },
  methods: {
    copyComponentId() {
      let target = null
      target = document.querySelector("#componentId")
      target.select()
      let copyResult = document.execCommand("copy")
      window.getSelection().removeAllRanges()
      this.showChangeId = false
      if (copyResult) {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          message: "已复制到剪切板",
          type: "success"
        })
      } else {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          message: "复制失败",
          type: "error"
        })
      }
    },
    editComponentId() {
      this.showChangeId = true
      this.$nextTick(() => {
        this.$refs.componentNameInp.focus()
      })
    },
    getComponentIdFocus(event) {
      if (this.showChangeId) {
        event.currentTarget.select()
      }
    },
    async changeComponentName($event, type) {
      this.showChangeId = false
      let ipt = document.getElementsByClassName("component-id-inp")[0]
      let newVal = type === 1 ? $event.target.value.trim() : ipt && ipt.value
      if (type === 2) {
        return
      }
      if (newVal === this.curRectInfoVal.appId) {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          type: "error",
          message: "组件ID未发生变化"
        })
        return
      }
      this.curRectInfoVal.appId = newVal
      if (newVal.length !== 36) {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          type: "error",
          message: "组件ID不存在"
        })
        return
      }
      this.$confirm("修改组件ID将永久清除全部后台数据！含本地数据、外接数据源配置，请备份数据。", "", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        showClose: false,
        dangerouslyUseHTMLString: "<p>修改组件ID将永久清除全部后台数据！含本地数据、外接数据源配置，请备份数据。</p>",
        iconClass: "bigScreen_confirm_icon el-icon-warning",
        cancelButtonClass: "bigScreen_confirm_cancel_button",
        confirmButtonClass: "bigScreen_confirm_button",
        customClass: "bigScreen_confirm custom_warning_dialog"
      })
        .then(() => {
          this.handleAppId(newVal)
        }).catch((err) => {
        let message = err.message.indexOf("30001") > -1 ? '组件ID只能来自当前网站':'修改失败'
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          type: "error",
          message: message
        })
      })
    },
    async handleAppId(newVal) {
      let res = await this.$API.getComponentPermission({
        appId: newVal
      })
      if (res.data.code === 1 && res.data.data && res.data.data.isSadmin && res.data.data.isBelong) {
        this.$changeOptionsEV(newVal, "appId", false)
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          type: "success",
          message: "修改成功"
        })
        return
      }
      let message = "修改失败"
      if (res.data.code === 1 && res.data.data && !res.data.data.isBelong) {
        message = "组件ID只能来自当前网站"
      }
      this.$message({
        customClass: "bigScreen_msg_backGroud",
        duration: 3000,
        type: "error",
        message: message
      })
    }
  }
}
</script>
<style scoped>
.changeRectAppIdDialog .w76{
  display: inline-block;
  width: 76px;
  color: #999;
}
.content-item{
  color: #000;
  font-size: 13px;
  line-height: 22px;
}
.component-id-inp{
  margin-right: 16px;
  width: 285px;
  line-height: 32px;
  color: #000;
}
.content-item .editing .component-id-inp{
  background-color: #F3F3F3;
  padding: 0 12px;
  border-radius: 4px;
  color: rgba(0, 0, 0, 0.8);
}
.content-item .icon{
  display: inline-block;
  font-size: 12px;
  line-height: 18px;
  width: 18px;
  text-align: center;
  cursor: pointer;
  border-radius: 4px;
  color: rgba(0,0,0,0.4);
}
.content-item .icon:hover{
  background-color: #FFDCDC;
}
.content-item .editing .icon{
  width: 28px;
  line-height: 28px;
  font-size: 16px;
}
</style>